import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fi from './fi'
import en from './en'
import se from './se'

Vue.use(VueI18n)

const messages = {
  en: en,
  fi: fi,
  se: se,
}

const i18n = new VueI18n({
  locale: 'fi',
  fallbackLocale: 'fi',
  silentTranslationWarn: true,
  messages,
})

export default i18n
